export default __webpack_public_path__ + "static/media/text-icon-white.8bbabcc6.svg";